import { formatPrice, isStrEmpty, formatDateUTC20 } from "@/utils/utils";
import languageMixins from "@/mixins/language/language-mixins";

export default {
    mixins: [languageMixins],
    data() {},
    methods: {
        printSports(printParam) {
            let userInfo = this.$store.state.userInfo;

            const betStorage = JSON.parse(printParam);
            const voucher = betStorage[0].voucher;
            const transactions = betStorage[0].transactions;

            let printerData = {};

            if (!isStrEmpty(userInfo.config.printerData?.logo)) {
                printerData["logo"] = userInfo.config.printerData.logo;
            }

            printerData["title"] = [
                {
                    type: "printEmptyLines",
                    line: 1,
                },
                {
                    type: "printTextCustom",
                    value: this.getTranslatedText("sports"),
                    fontSize: 30,
                    isBold: true,
                    isUnderline: false,
                    font: "",
                    alignment: 1,
                },
                {
                    type: "printEmptyLines",
                    line: 1,
                },
            ];

            for (const transaction of transactions) {
                let winningBeforeTax = formatPrice(
                    parseFloat(transaction.winning_before_tax)
                );
                let winningAfterTax = formatPrice(
                    parseFloat(transaction.winning_after_tax)
                );
                let withholdingTax = formatPrice(
                    parseFloat(transaction.winnings_tax_amount)
                );
                let tax = `${parseFloat(transaction.winnings_tax) * 100}%`;

                let totalOdds = formatPrice(parseFloat(transaction.odds_total));
                let wager = formatPrice(parseFloat(transaction.stake));

                const bets = transaction.bets;

                printerData["header"] = [
                    {
                        label: `${this.getTranslatedText("Date")}:`,
                        value: `${voucher.created_at.split(".")[0]}`,
                        type: "printTable",
                        column: [2, 4],
                        align: [0, 2],
                        isBold: true,
                        isUnderline: false,
                    },
                    {
                        label: this.getTranslatedText("betslip ID"),
                        value: `${transaction.external_bet_id}`,
                        type: "printTable",
                        column: [3, 3],
                        align: [0, 2],
                        isBold: true,
                        isUnderline: false,
                    },
                ];

                let typeBeslip = "";

                if (transaction.bets.length > 1) {
                    typeBeslip = `---${this.getTranslatedText("Multiple")} : (${
                        transaction.bets.length
                    }) '${this.getTranslatedText("lines")}' ---`;
                } else {
                    typeBeslip = `----------- ${this.getTranslatedText(
                        "Simple"
                    )} -----------`;
                }

                printerData["titleBody"] = [
                    {
                        type: "printEmptyLines",
                        line: 1,
                    },
                    {
                        type: "printText",
                        value: typeBeslip,
                    },
                    {
                        type: "printEmptyLines",
                        line: 1,
                    },
                    {
                        type: "setAlignLeft",
                    },
                ];

                let body = [];

                for (var b = 0; b < bets.length; b++) {
                    let item = [
                        {
                            type: "printTextCustom",
                            value: `${
                                transaction.bets.length > 1
                                    ? "[" + (b + 1) + "] "
                                    : ""
                            }${transaction.bets[b].tournament_name}\n`,
                            fontSize: 24,
                            isBold: true,
                            isUnderline: false,
                            font: "",
                        },
                        {
                            type: "printTextCustom",
                            value: `${
                                bets[b].match_name_no_date || bets[b].match_name
                            }`,
                            fontSize: 24,
                            isBold: false,
                            isUnderline: false,
                            font: "",
                        },
                        {
                            type: "printTextCustom",
                            value: `${bets[b].draw_time}`,
                            fontSize: 24,
                            isBold: false,
                            isUnderline: false,
                            font: "",
                        },
                        {
                            type: "printTextCustom",
                            value: `\n${bets[b].market_name}: ${bets[b].outcome_name} @ ${bets[b].odd}`,
                            fontSize: 24,
                            isBold: true,
                            isUnderline: false,
                            font: "",
                        },
                    ];

                    if (b <= bets.length - 2) {
                        let items = {
                            type: "printCutDashLine",
                        };

                        item.push(items);
                    }

                    body.push(...item);
                }

                const footer = [
                    {
                        type: "printDashLine",
                    },
                    {
                        type: "printEmptyLines",
                        line: 1,
                    },
                    {
                        type: "printTable",
                        label: this.getTranslatedText("Total odds"),
                        value: totalOdds,
                        column: [2, 2],
                        align: [0, 2],
                        isBold: true,
                    },
                    {
                        type: "printTable",
                        label: this.getTranslatedText("Wager"),
                        value: wager,
                        column: [2, 2],
                        align: [0, 2],
                        isBold: true,
                    },
                    {
                        type: "printTable",
                        label: this.getTranslatedText(
                            "Earnings before deduction"
                        ),
                        value: winningBeforeTax,
                        column: [4, 2],
                        align: [0, 2],
                        isBold: true,
                    },
                    {
                        type: "printTable",
                        label: this.getTranslatedText("Withholding [tax]", {
                            tax: tax,
                        }),
                        value: withholdingTax,
                        column: [4, 2],
                        align: [0, 2],
                        isBold: true,
                    },
                    {
                        type: "printTable",
                        label: this.getTranslatedText("Potential Earnings"),
                        value: winningAfterTax,
                        column: [4, 2],
                        align: [0, 2],
                        isBold: true,
                    },
                    {
                        type: "setAlignCenter",
                    },
                    {
                        type: "printEmptyLines",
                        line: 1,
                    },
                    {
                        type: "barcode",
                        value: transaction.external_bet_id.startsWith("S-")
                            ? transaction.external_bet_id
                            : `S-${transaction.external_bet_id}`,
                        isShowCode: true,
                    },
                    {
                        type: "printEmptyLines",
                        line: 4,
                    },
                ];

                printerData["body"] = body;
                printerData["footer"] = footer;
            }

            parent.postMessage(
                {
                    command: "print-common",
                    param: printerData,
                },
                "*"
            );
        },

        printSettle(printParam) {
            let printerData = {};
            let userInfo = this.$store.state.userInfo;
            let date = formatDateUTC20(printParam.date);
            let datePrint = `${date.day}/${date.month}/${date.year} ${date.hour}:${date.minutes}`;
            if (!isStrEmpty(userInfo.config.printerData?.logo)) {
                printerData["logo"] = userInfo.config.printerData.logo;
            }

            printerData["body"] = [
                {
                    type: "printEmptyLines",
                    line: 1,
                },
                {
                    type: "printTextCustom",
                    value: printParam?.isTestPrint
                        ? this.getTranslatedText("test print")
                        : this.getTranslatedText("receipt"),
                    fontSize: 30,
                    isBold: true,
                    isUnderline: false,
                    font: "",
                    alignment: 1,
                },
                {
                    type: "printEmptyLines",
                    line: 1,
                },
                {
                    type: "printTextCustom",
                    value: `${this.getTranslatedText("date")}: ${datePrint}`,
                    fontSize: 30,
                    isBold: true,
                    isUnderline: false,
                    font: "",
                },
                {
                    type: "printTextCustom",
                    value: `${this.getTranslatedText("branch")}: ${
                        printParam.branch_name
                    }`,
                    fontSize: 30,
                    isBold: true,
                    isUnderline: false,
                    font: "",
                },
                {
                    type: "printTextCustom",
                    value: `${this.getTranslatedText("cashier")}: ${
                        printParam.cashier_name
                    }`,
                    fontSize: 30,
                    isBold: true,
                    isUnderline: false,
                    font: "",
                },
                {
                    type: "printTextCustom",
                    value: `${this.getTranslatedText("code")}: ${
                        printParam.code
                    }`,
                    fontSize: 30,
                    isBold: true,
                    isUnderline: false,
                    font: "",
                },

                {
                    type: "printTextCustom",
                    value: `${this.getTranslatedText("settlement")}: ${
                        printParam.currency_code + " " + printParam.amount
                    }`,
                    fontSize: 30,
                    isBold: true,
                    isUnderline: false,
                    font: "",
                },
                {
                    type: "printEmptyLines",
                    line: 1,
                },
                {
                    type: "barcode",
                    value: printParam.code,
                    isShowCode: true,
                },
                {
                    type: "printEmptyLines",
                    line: 4,
                },
            ];

            parent.postMessage(
                {
                    command: "print-common",
                    param: printerData,
                },
                "*"
            );
        },

        printReport(printParam) {
            let printerData = {};
            let userInfo = this.$store.state.userInfo;
            let currentDate = formatDateUTC20(new Date());
            let printDate = `${currentDate.day}/${currentDate.month}/${currentDate.year} ${currentDate.hour}:${currentDate.minutes}`;

            let today = `${currentDate.year}-${currentDate.month}-${currentDate.day}`;
            let trueBalance =
                printParam.from === printParam.to && printParam.from === today
                    ? printParam.sum.true_balance
                    : printParam.sum.cash_difference;
            let reports = printParam.report.filter(
                (item) =>
                    item.hasOwnProperty("product_type") && item["product_type"]
            );
            let reportParams = [];
            let endPaper = [
                {
                    type: "printEmptyLines",
                    line: 4,
                },
            ];
            // to do report
            reports.forEach((r) => {
                let item = [
                    {
                        type: "printEmptyLines",
                        line: 1,
                    },
                    {
                        type: "printTextCustom",
                        value: `${r.product_type}`,
                        fontSize: 24,
                        isBold: true,
                        isUnderline: false,
                        font: "",
                        alignment: 1,
                    },
                    {
                        type: "printTextCustom",
                        value: `${this.getTranslatedText(
                            "wager"
                        )}: ${formatPrice(
                            parseFloat(
                                r.wagers - printParam.sum.refunded_cancelations
                            )
                        )}`,
                        fontSize: 24,
                        isBold: false,
                        isUnderline: false,
                        font: "",
                    },
                    {
                        type: "printTextCustom",
                        value: `${this.getTranslatedText(
                            "payouts"
                        )}: ${formatPrice(parseFloat(r.payouts))}`,
                        fontSize: 24,
                        isBold: false,
                        isUnderline: false,
                        font: "",
                    },
                ];

                reportParams.push(...item);
            });

            if (!isStrEmpty(userInfo.config.printerData?.logo)) {
                printerData["logo"] = userInfo.config.printerData.logo;
            }

            printerData["body"] = [
                {
                    type: "printEmptyLines",
                    line: 1,
                },
                {
                    type: "printTextCustom",
                    value: printParam.isFinal
                        ? this.getTranslatedText("final report of")
                        : this.getTranslatedText("report of"),
                    fontSize: 30,
                    isBold: true,
                    isUnderline: false,
                    font: "",
                    alignment: 1,
                },
                {
                    type: "printTextCustom",
                    value: `${printParam.cashier.first_name} ${printParam.cashier.last_name}`,
                    fontSize: 30,
                    isBold: true,
                    isUnderline: false,
                    font: "",
                    alignment: 1,
                },
                {
                    type: "printEmptyLines",
                    line: 1,
                },
                {
                    type: "printTextCustom",
                    value: `${this.getTranslatedText("report date")}`,
                    fontSize: 30,
                    isBold: false,
                    isUnderline: false,
                    font: "",
                    alignment: 1,
                },
                {
                    type: "printTextCustom",
                    value: `${printParam.date}`,
                    fontSize: 30,
                    isBold: false,
                    isUnderline: false,
                    font: "",
                    alignment: 1,
                },
                {
                    type: "printTextCustom",
                    value: `${this.getTranslatedText("print date")}`,
                    fontSize: 30,
                    isBold: false,
                    isUnderline: false,
                    font: "",
                    alignment: 1,
                },
                {
                    type: "printTextCustom",
                    value: `${printDate}`,
                    fontSize: 30,
                    isBold: false,
                    isUnderline: false,
                    font: "",
                    alignment: 1,
                },
                {
                    type: "printEmptyLines",
                    line: 1,
                },
                {
                    type: "printTextCustom",
                    value: `${this.getTranslatedText("summary")}`,
                    fontSize: 30,
                    isBold: true,
                    isUnderline: false,
                    font: "",
                    alignment: 1,
                },
                {
                    type: "printTextCustom",
                    value: `${this.getTranslatedText("cash deposits")}: ${
                        printParam.sum.currency
                    } ${formatPrice(parseFloat(printParam.sum.cash_deposits))}`,
                    fontSize: 30,
                    isBold: false,
                    isUnderline: false,
                    font: "",
                },
                {
                    type: "printTextCustom",
                    value: `${this.getTranslatedText("cancellations")}: ${
                        printParam.sum.currency
                    } ${formatPrice(
                        parseFloat(printParam.sum.refunded_cancelations)
                    )}`,
                    fontSize: 30,
                    isBold: false,
                    isUnderline: false,
                    font: "",
                },
                {
                    type: "printTextCustom",
                    value: `${this.getTranslatedText("payouts")}: ${
                        printParam.sum.currency
                    } ${formatPrice(parseFloat(printParam.sum.payouts))}`,
                    fontSize: 30,
                    isBold: false,
                    isUnderline: false,
                    font: "",
                },
                {
                    type: "printTextCustom",
                    value: `${this.getTranslatedText("true balance")}: ${
                        printParam.sum.currency
                    } ${formatPrice(parseFloat(trueBalance))}`,
                    fontSize: 30,
                    isBold: true,
                    isUnderline: false,
                    font: "",
                },
            ];

            printerData["body"].push(...reportParams);
            printerData["body"].push(...endPaper);
            parent.postMessage(
                {
                    command: "print-common",
                    param: printerData,
                },
                "*"
            );
        },

        printVoucher(printParam) {
            let userInfo = this.$store.state.userInfo;

            let datePrint = formatDateUTC20(new Date());

            datePrint = `${datePrint.day}-${datePrint.month}-${datePrint.year} ${datePrint.hour}:${datePrint.minutes}`;

            const isPayment = printParam.isPayment;
            const isCancel = printParam.isCancel;

            const titleVoucher = isPayment
                ? "Ludwin paiment voucher"
                : isCancel
                ? "annulation voucher"
                : "Ludwin voucher";

            let printerData = {};
            printerData["logo"] = "";
            if (!isStrEmpty(userInfo.config.printerData?.logo)) {
                printerData["logo"] = userInfo.config.printerData.logo;
            }

            printerData["body"] = [
                {
                    type: "printEmptyLines",
                    line: 1,
                },
                {
                    type: "setAlignCenter",
                    line: 1,
                },
                {
                    type: "printTextCustom",
                    value: `${this.getTranslatedText(titleVoucher)}`,
                    fontSize: 24,
                    isBold: true,
                    isUnderline: false,
                    alignment: 1,
                },
                {
                    label: `${this.getTranslatedText("date")}:`,
                    value: `${datePrint}`,
                    type: "printTable",
                    column: [2, 4],
                    align: [0, 2],
                    isBold: true,
                    isUnderline: false,
                },
                {
                    label: `${this.getTranslatedText("amount")}:`,
                    value: `${printParam.amount} ${printParam.currency}`,
                    type: "printTable",
                    column: [2, 4],
                    align: [0, 2],
                    isBold: true,
                    isUnderline: false,
                },
                {
                    type: "printDashLine",
                },
                {
                    type: "printEmptyLines",
                    line: 1,
                },
                {
                    type: "printDashLine",
                },
                {
                    type: "printEmptyLines",
                    line: 1,
                },
                {
                    type: "printTextCustom",
                    value: `${this.getTranslatedText("Ludwin")}`,
                    fontSize: 24,
                    isBold: true,
                    isUnderline: false,
                    alignment: 1,
                },
                {
                    type: "printEmptyLines",
                    line: 4,
                },
            ];

            if (isCancel) {
                let item = {
                    type: "printTextCustom",
                    value: `${this.getTranslatedText(printParam.voucherCode)}`,
                    fontSize: 24,
                    isBold: true,
                    isUnderline: false,
                    alignment: 1,
                };

                printerData["body"].splice(7, 0, item);
            }

            if (!isCancel && !isPayment) {
                const expirationdate = this.convertDateString(
                    printParam.expirationdate
                );

                let item = {
                    label: `${this.getTranslatedText("expiry date")}:`,
                    value: `${expirationdate}`,
                    type: "printTable",
                    column: [4, 3],
                    align: [0, 2],
                    isBold: true,
                    isUnderline: false,
                };

                printerData["body"].splice(5, 0, item);
            }

            if (!isCancel) {
                let item = {
                    type: "barcode",
                    value: printParam.voucherCode,
                    isShowCode: true,
                    printTypeBarcode: 'CODABAR_BARCODE_TYPE_CONSTANT'
                }

                const locationItem = !isCancel && !isPayment ? 8 : 7;

                printerData["body"].splice(locationItem, 0, item);
            }

            parent.postMessage(
                {
                    command: "print-common",
                    param: printerData,
                },
                "*"
            );
        },

        convertDateString(input) {
            const year = input.substr(0, 4);
            const month = input.substr(4, 2);
            const day = input.substr(6, 2);

            const output = `${day}/${month}/${year}`;
            return output;
        },
    },
};
